module.exports = __webpack_public_path__ + "img/8.b5b4ece6.jpg";